import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const PurchaseReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No purchase report data found." />
);

export default PurchaseReport;
